export default __webpack_public_path__ + "static/media/heart.e670d407.svg";